import { useState } from 'react';

import { Alert } from '@/shared/ui/alert';
import { Button } from '@/shared/ui/button';
import { Dialog } from '@/shared/ui/dialog';
import { DropdownMenu, MenuDivider, MenuItem, MenuLabel } from '@/shared/ui/dropdown-menu';
import { EmptyState } from '@/shared/ui/empty-state';
import { toast, ToastHost } from '@/shared/ui/feedback';
import { Panel, PanelGroup } from '@/shared/ui/panel';

export function OverlaysSection() {
  const [confirm, setConfirm] = useState(false);
  return (
    <>
      <PanelGroup gap={12}>
        <Panel title="Alerts" icon="info">
          <div className="gap-phx-3 flex flex-col">
            <Alert severity="info" title="Heads up">
              The series schedule has been recalculated from the new transport plan.
            </Alert>
            <Alert severity="success" title="Saved">
              All changes were saved to the production agenda.
            </Alert>
            <Alert severity="warning" title="Partial">
              5 of 17 terms are still placeholders — confirm before publishing.
            </Alert>
            <Alert severity="error" title="Failed">
              Could not contact the pricing service. Retry in a moment.
            </Alert>
          </div>
        </Panel>

        <Panel title="Toasts" icon="notif">
          <div className="gap-phx-3 flex flex-wrap">
            <Button
              size="sm"
              variant="default"
              onClick={() => toast({ severity: 'info', description: 'Snapshot captured at 14:02' })}
            >
              Info
            </Button>
            <Button
              size="sm"
              variant="primary"
              onClick={() =>
                toast({
                  severity: 'success',
                  title: 'Done',
                  description: 'Production publish complete',
                })
              }
            >
              Success
            </Button>
            <Button
              size="sm"
              onClick={() =>
                toast({
                  severity: 'warning',
                  description: '5 of 17 terms still placeholder',
                })
              }
            >
              Warning
            </Button>
            <Button
              size="sm"
              variant="danger"
              onClick={() => toast({ severity: 'error', description: 'Pricing service offline' })}
            >
              Error
            </Button>
          </div>
        </Panel>

        <Panel title="Dropdown menu" icon="morev">
          <DropdownMenu
            trigger={
              <Button variant="default" iconRight="chevdown">
                Open menu
              </Button>
            }
          >
            <MenuLabel>Layer actions</MenuLabel>
            <MenuItem icon="edit">Edit</MenuItem>
            <MenuItem icon="copy" hint="Ctrl+D">
              Duplicate
            </MenuItem>
            <MenuItem icon="detach" hint="Open in new window">
              Detach
            </MenuItem>
            <MenuDivider />
            <MenuItem icon="trash" tone="danger">
              Delete
            </MenuItem>
          </DropdownMenu>
        </Panel>

        <Panel title="Dialog" icon="open">
          <Button variant="primary" onClick={() => setConfirm(true)}>
            Open dialog
          </Button>
          <Dialog
            open={confirm}
            onClose={() => setConfirm(false)}
            title="Discard unsaved changes?"
            description="Your last 5 edits will be lost. This action cannot be undone."
            icon="alert"
            tone="danger"
            footer={
              <>
                <Button variant="outline" onClick={() => setConfirm(false)}>
                  Cancel
                </Button>
                <Button variant="danger" onClick={() => setConfirm(false)}>
                  Discard
                </Button>
              </>
            }
          />
        </Panel>

        <Panel title="Empty state" icon="folder">
          <EmptyState
            icon="folder"
            title="No agendas yet"
            description="Start by creating a new series or import a snapshot from the legacy system."
            action={{
              label: 'Create series',
              onClick: () => toast({ severity: 'info', description: 'Open series wizard' }),
            }}
          />
        </Panel>
      </PanelGroup>

      <ToastHost />
    </>
  );
}
